<template>
  <div class="disk-modal">
    <el-dialog
      :close-on-click-modal="false"
      :title="$t('ecc.storage.mountDialog.header')"
      :visible="visible"
      width="710px"
      :before-close="handleClose"
    >
      <el-form>
        <el-form-item :label="$t('ecc.storage.mountDialog.disk')" label-width="220px">
          <el-input v-model="disk.tag" readonly/>
        </el-form-item>
        <el-form-item :label="$t('ecc.storage.mountDialog.instance')" label-width="220px">
          <el-select v-model="instanceSn">
            <el-option v-for="ins in instances" v-bind:key="ins.id" :label="ins.name" :value="ins.sn"></el-option>
          </el-select>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="visible = false">{{ $t('ecc.storage.mountDialog.buttons.cancel') }}</el-button>
        <el-button type="primary" @click="mount">{{ $t('ecc.storage.mountDialog.buttons.mount') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      visible: false,
      disk: {},
      instances: [],
      instanceSn: '',
    };
  },
  watch: {
    visible: {
      handler(n, o) {
        this.visible = n;
        if (n) {
          this.getInstances()
        }
      },
    },
  },
  mounted() {
  },
  props: {},
  methods: {
    async mount() {
      if (!this.instanceSn) {
        this.$message.error('Please choose a instance to mount')
        return false
      }
      let data = {
        sn: this.disk.sn,
        instance_sn: this.instanceSn
      }
      let res = await this.$http.post('/disks/mount', data).then((res) => {
        return res
      }).catch((err) => {
        return err
      })
      if (res.status !== 200) {
        this.$message.error(res.statusText)
        return false
      }
      res = res.data
      if (res.code === -1) {
        this.$message.error(res.message)
        return false
      }
      this.$message.success(res.message)
      this.visible = false
      this.$emit('reload-detail');
    },
    getInstances() {
      let data = {
        disk_sn: this.disk.sn,
        regions: [this.disk.region_id],
        limit: 1000
      }
      this.$http.get('/ecc/instances', data).then((res) => {
        res = res.data
        if (res.code === -1) {
          this.$message.error(res.message)
          return false
        }
        this.instances = res.data.data
      }).catch((err) => {

      })
    },
    handleClose() {
      this.visible = false;
    },
    showChange() {
      this.visible = !this.visible;
    },
  },
};
</script>

<style scoped lang="scss">
.disk-modal {
  .input-tips {
    color: #acb4bf;
    font-size: 12px;
    line-height: 20px;
    margin-top: 6px;
  }

  .text {
    font-weight: bold;
  }
}
</style>
<style>
.disk-modal .el-select {
  display: block;
}

.disk-modal .el-form-item__label {
  color: #5e6d81;
  font-size: 14px;
  font-weight: normal;
  opacity: 0.8;
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/components/server/DiskMount.vue